const mFeedProductsContentModalCreate = {
  mFeedProductsContentModalCreate: {
    alerts: {
      createProducto: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El producto fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      nombre: {
        label: 'Escribe aquí un nombre',
        message: '* De 5 a 120 caracteres'
      },
      alumnos: {
        label: 'Cantidad maxima de alumnos que podrá tener la licencia',
        message: '* Solo numeros enteros'
      },
      proyectos: {
        label: 'Cantidad maxima de cursos que podrá tener la licencia',
        message: '* Solo numeros enteros'
      },
      emails: {
        label: 'Cantidad maxima de emails que podrá enviar la academia',
        message: '* Solo numeros enteros'
      }
    },

    title: 'Nuevo Producto',
    titleVidroop: 'Nuevo Producto Vidroop',

    validation: {
      producto: {
        nombre: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 5 caracteres.',
          required: 'Nombre de producto es requerido. De 5 a 60 caracteres.'
        },

        alumnos: {
          numeric: 'Cantidad debe ser un entero.',
          required: 'Cantidad maxima de alumnos es requerida.'
        },

        proyectos: {
          numeric: 'Cantidad debe ser un entero.',
          required: 'Cantidad maxima de cursos es requerida.'
        },

        emails: {
          numeric: 'Cantidad debe ser un entero.',
          required: 'Cantidad maxima de emails es requerida.'
        }
      }

      /* productoVidroop: {
        producto: {
        }
      } */
    }
  }
}

export default mFeedProductsContentModalCreate
